import VueCookies from 'vue-cookies'
import apiClient from '@/utils/axios'

import {Question} from '@/types'
import {apiEndPoints} from '@/utils/constant'
import {AxiosResponse} from 'axios'

const {QUESTION_URL, REPLIED_QUERIES_URL, ANSWER_URL, UNANSWERED_QUESTIONS_URL} = apiEndPoints

interface QuestionService {
  get(): Promise<AxiosResponse<Question[]>>
  getById(id: string): Promise<AxiosResponse<Question>>
  create(payload: Question): Promise<AxiosResponse<Question>>
  update(question: Question, id: string): Promise<AxiosResponse<Question>>
  delete(id: string): Promise<AxiosResponse<string>>
  getQuestionByUserId(): Promise<object>
  getRepliedQueries(): Promise<object>
  getUnAnsweredQuestions(): Promise<object>
  postAnswer(data: {comment: string}): Promise<AxiosResponse<string>>
}

const question: QuestionService = {
  async get(): Promise<AxiosResponse<Question[]>> {
    const response = await apiClient.get(QUESTION_URL)
    return response
  },

  async getById(id: string): Promise<AxiosResponse<Question>> {
    const response = await apiClient.get(`${QUESTION_URL}/${id}`)
    return response
  },

  async create(payload: Question): Promise<AxiosResponse<Question>> {
    const response = await apiClient.post(QUESTION_URL, payload)
    return response
  },

  async update(question: Question, id: string): Promise<AxiosResponse<Question>> {
    const response = await apiClient.put(`${QUESTION_URL}/${id}`, question)
    return response
  },

  async delete(id: string): Promise<AxiosResponse<string>> {
    const response = await apiClient.delete(`${QUESTION_URL}/${id}`)
    return response
  },

  async getQuestionByUserId() {
    const userId = (VueCookies.get('auth').user_id)
    const response = await apiClient.get(`users/${userId}/${QUESTION_URL}`)
    return response
  },

  async getRepliedQueries() {
    const response = await apiClient.get(REPLIED_QUERIES_URL)
    return response
  },

  async getUnAnsweredQuestions() {
    const response = await apiClient.get(UNANSWERED_QUESTIONS_URL)
    return response
  },

  async postAnswer(answerData) {
    const response = await apiClient.post(ANSWER_URL, answerData)
    return response
  },
}

export {question}
